
import {  Vue, Component, Prop } from 'vue-property-decorator';
import {
  Dialog,
  Button,
  Row,
  Col,
  Select,
  Option,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
} from 'element-ui';

  @Component({
    components: {
      Dialog,
      Button,
      Row,
      Col,
      Select,
      Option,
      CheckboxGroup,
      Checkbox,
      RadioGroup,
      Radio,
    },
  })
export default class questionModal extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  })viewVis!: boolean;

  @Prop({
    type: Object,
  })questionViewProp!: object;

  private visible: boolean = this.viewVis;

  OnClose() {
    this.$emit('update:viewVis', false);
  }
}
